import React, { useEffect } from 'react';
import { setPageChange, PageTypesForNative } from '../../system-utils/common-utils';
import { TEXT_ERROR_PAGE_BUTTON, TEXT_ERROR_PAGE_HEADER, TEXT_ERROR_PAGE_DEFAULT_DESCRIPTION } from '../ui-component-constants';

import Header from '../Header';
import Footer from '../Footer';
import FullPageErrorContent from '../FullPageErrorContent';

type Props = {
  description?: string;
  isNativeView?: boolean;
};

export const ErrorPage: React.FC<Props> = ({ description, isNativeView = false }) => {
  useEffect(() => {
    setPageChange(PageTypesForNative.ERROR);
  }, []);

  const onTryAgainClick = () => {
    window.location.reload();
  };

  if (!isNativeView) {
    return (
      <>
        <Header />
        <FullPageErrorContent pageTitle={'Error'} title={TEXT_ERROR_PAGE_HEADER} description={description ?? TEXT_ERROR_PAGE_DEFAULT_DESCRIPTION} ctaText={TEXT_ERROR_PAGE_BUTTON} onCtaClick={onTryAgainClick} dataTestId='nba-error-page' />
        <Footer />
      </>
    );
  }
  return <FullPageErrorContent pageTitle={'Error'} title={TEXT_ERROR_PAGE_HEADER} description={description ?? TEXT_ERROR_PAGE_DEFAULT_DESCRIPTION} dataTestId='nba-error-page-native' />;
};
